module.exports = __webpack_public_path__ + "img/06-green.7a8a194f.svg";